enum Routes {
  Home = 'home',
  Categories = 'categories',
  Category = 'category',
  Profile = 'profile',
  ProfileEdit = 'profile-edit',
  UserOrders = 'user-orders',
  UserOrderDetail = 'user-order-detail',
  Addresses = 'addresses',
  ShoppingCart = 'shopping-cart',
  Register = 'register',
  ProductDetail = 'product-detail',
  ProductSearch = 'product-search',
  OrderAddressStep = 'order-checkout-address',
  OrderAddressChange = 'order-checkout-address-change',
  OrderDeliveryStep = 'order-checkout-delivery',
  OrderPaymentStep = 'order-checkout-payment',
  OrderTransactionStep = 'order-checkout-transaction',
  OrderSummaryStep = 'order-checkout-summary',
  OrderSuccess = 'order-success',
  OrderFailure = 'order-failure',
  DeliverySelection = 'delivery-selection',
  EssentialProducts = 'essential-products',
  CmsDynamicPage = 'cms-dynamic-page',
  NotFound = 'not-found',
  RegisterConfirmation = 'register-confirmation',
}

export default Routes;
